<template lang="pug">
    div
        v-card
            v-layout(row wrap)
                v-flex(md8)
                    v-autocomplete.mx-3.pl-5.pr-5.pt-4(
                                v-model="employeeId" 
                                :items="employees"
                                item-text="fullName"
                                item-value ="id"
                            )
                                div.formLabel(slot="prepend")
                                    | Empleado
                v-flex(md2)
                    v-btn.mt-4(block color="info" outline) Limpiar Formulario
        crud-form(
            :fields="fields" 
            noButtons 
            @submitForm="precedentFormSubmit" 
            ref="precedentForm"
            )
            div(slot="appendContent")
                v-btn( 
                    v-if="employeeId"
                    block 
                    color="success" 
                    @click="validateForm"
                    )
                    | Siguiente
</template>

<script>
/* components */
import { CrudForm } from '@/components/reusable_components/'
/* fields */
import PrecedentFields from './fields'
/* services */
import EmployeeService from '@/services/api/employee'
import HrCausalService from '@/services/api/hrCausal'
export default {
    name: 'precedent-tab',
    // props: {},
    data: function() {
        return {
            fields: PrecedentFields,
            employeeId: null,
            employees: [],
        }
    },
    computed: {},
    methods: {
        // -- UI Modification
        // -- Data fetching
        async fetchEmployees() {
            return await EmployeeService.fetchAll()
        },
        // -- Data handling and transformations
        /**
         * setEmployees function
         * set data for employee for using in autocomplete
         */
        async setEmployees() {
            let employees = await this.fetchEmployees()
            employees = this.formatEmployees(employees)
            this.employees = employees
        },
        /**
         * formatEmployees function
         * Added full_name as a new value in array employee
         * @param array employee
         * @returns array employee
         */
        formatEmployees(employees) {
            return employees.map(employee => {
                let newEmployee = employee
                newEmployee.fullName = `${employee.names} ${
                    employee.last_name1
                } ${employee.last_name2}`
                return newEmployee
            })
        },
        /**
         *
         */
        setContractInitDate(employee) {
            let contract = employee.active_contract
            if (contract) {
                let setFields = [...this.fields]
                setFields[0].value = contract.init_date
                this.fields = [...setFields]
            }
        },
        /**
         * fetchCausales
         * @returns array Causales despido
         */
        async fetchCausales() {
            return await HrCausalService.fetchAll()
        },
        async setCausales() {
            let causales = await this.fetchCausales()
            let setFields = [...this.fields]
            setFields[4].options.data = causales
            this.fields = [...setFields]
        },
        /**
         * precedentFormSubmit
         * event returns a valid form
         */
        precedentFormSubmit(formData) {
            let data = this.addEmployeeToObject(formData)
            this.$emit('precedentFormDone', data)
        },

        validateForm() {
            this.$refs.precedentForm.submitForm()
            //alert('ire a tab2 ')
        },
        /**
         *
         */
        addEmployeeToObject(formData) {
            let data = { ...formData }
            data.hr_employee_id = this.employeeId
            data.full_name_employee = this.getFullNameEmployee(this.employeeId)
            return data
        },
        /**
         *
         */
        getFullNameEmployee(employeeId) {
            let employee = this.findEmployee(employeeId)
            return employee.fullName
        },
        /**
         *
         */
        findEmployee(employeeId) {
            return this.employees.find(employee => employee.id === employeeId)
        },
        cleanForms(){
            this.$refs.precedentForm.$refs.form.reset
        },

        // -- Validations and Error handling
        // -- Other functions

        // -- Vuex mappings
    },
    watch: {
        employeeId(employeeId) {
            let employee = this.employees.find(
                employee => employee.id === employeeId
            )
            this.setContractInitDate(employee)
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.setEmployees()
        this.setCausales()
    },
    mounted () {
        this.cleanForms()
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
.formLabel {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 20px;
}
</style>